import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import { CarOption } from '@/scopes/checkout/components/services/CarRentalFilteringService/CarOption'
import { Carousel, Slide } from '@/scopes/checkout/components/services/CarRentalFilteringService/Carousel'
import { RentalCarListerView } from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/RentalCarListerView'
import {
  carToBeSelected,
  useCarRentalFilteringServiceStore,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/store'
import { useService } from '@/scopes/checkout/domain/hooks'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { ServiceType } from '../../../domain/types'
import styles from './CarsListView.module.css'

export function CarsListView() {
  const { service } = useService(ServiceType.CarRentalFiltering)
  const { isDesktopSm } = useBreakpoints()
  const intl = useIntl()
  const selectingCar = useCarRentalFilteringServiceStore(carToBeSelected)

  if (!service)
    return null

  const { options } = service

  return (
    <div className={styles.carListWrapper}>
      {!isDesktopSm && (
        <div className={styles.carRentalWrapper}>
          <Carousel>
            {Object.values(options ?? {})
              .slice(0, 3)
              .map(option => (
                <Slide key={option.value}>
                  <CarOption
                    key={option.value}
                    isSelected={String(option.value) === String(selectingCar)}
                    {...option}
                  />
                </Slide>
              ))}
          </Carousel>
        </div>
      )}
      {isDesktopSm
      && Object.values(options ?? {})
        .slice(0, 3)
        .map((option) => {
          return (
            <CarOption key={option.value} isSelected={String(option.value) === String(selectingCar)} {...option} />
          )
        })}

      <Typography className={styles.extraHintText}>
        {intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_extra_car_options' })}
      </Typography>
      <RentalCarListerView />
    </div>
  )
}
